// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__SbY8L","checkboxCol":"Table_checkboxCol__jrPVL","emailCol":"Table_emailCol__3JEWt","actionCol":"Table_actionCol__W8UX8"};